<!--
<app-notifications></app-notifications>
-->
<section class="content">
  <h1 class="">Nachlieferung</h1>
  @if (loading) {
    <mat-spinner [diameter]="50"></mat-spinner>
  }
  @if (!loading) {
    <div>
      <div class="d-flex jcsb aie">
        <p>
          <button mat-flat-button color="primary"
                  (click)="addNachlieferung()" [disabled]="!canEdit">Artikel Aufnehmen
            <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">post_add</mat-icon>
          </button>
        </p>
        <div>
          <p class="text-center">Download:</p>
          <p class="d-flex jcsb">
            <button mat-flat-button color="primary" (click)="downloadCsv()"><span>.csv</span></button>
            <button mat-flat-button class="ml-s" color="primary" (click)="downloadPdf()"><span>.pdf</span></button>
          </p>
        </div>
      </div>
      <mat-table [dataSource]="dataSource" class="shadow" matSort #dataTable matSortActive="orderdate"
                 matSortDirection="asc" matSortDisableClear>
        <!-- Order date Column -->
        <ng-container matColumnDef="orderdate">
          <mat-header-cell *matHeaderCellDef mat-sort-header=""> Datum</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.orderdate | date: 'shortDate' }}</mat-cell>
        </ng-container>
        <!-- PZN Column -->
        <ng-container matColumnDef="articlecode">
          <mat-header-cell *matHeaderCellDef mat-sort-header> PZN</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.articlecode }}</mat-cell>
        </ng-container>
        <!-- Product Name Column -->
        <ng-container matColumnDef="articlename">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Artikelname</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.articlename }}</mat-cell>
        </ng-container>
        <!-- Unit Column -->
        <ng-container matColumnDef="unit">
          <mat-header-cell *matHeaderCellDef> Einheit</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.unit }}</mat-cell>
        </ng-container>
        <!-- Quantity Column -->
        <ng-container matColumnDef="quantity">
          <mat-header-cell *matHeaderCellDef> Offene Bestellmenge</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.quantity }}
            @if (showEdit[element.position]) {
              <form [formGroup]="maxQuantityForm" class="table-edit d-flex ml-s"
                    (submit)="update(element.delivery)">
                <input name="updatedQuantity"
                       id="updatedQuantity-{{element.position}}"
                       type="text"
                       class="update-qty"
                       formControlName="maxQty"/>
                <button [disabled]="!maxQuantityForm.valid" type="submit"
                        [ngClass]="maxQuantityForm.valid ? 'cursor-pointer' : ''">
                  @if (!maxQuantityForm.valid) {
                    <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">block</mat-icon>
                  }
                  @if (maxQuantityForm.valid) {
                    <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">check</mat-icon>
                  }
                </button>
                @if (!maxQuantityForm.valid) {
                  <mat-error matTooltip="Eine Erhöhung der Menge ist nicht möglich.">
                    <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">help</mat-icon>
                  </mat-error>
                }
              </form>
            }
          </mat-cell>
        </ng-container>
        <!-- Info Supplier -->
        <ng-container matColumnDef="delivery_info">
          <mat-header-cell *matHeaderCellDef> Info lt. Hersteller</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.delivery_information.getDeliveryDate() | translate }}</mat-cell>
        </ng-container>
        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <a matTooltip="Bearbeiten"
               (click)="showForm(element.quantity); showEdit = []; showEdit[element.position] = !showEdit[element.position];"
               class="mr-s">
              <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">edit</mat-icon>
            </a>
            <a matTooltip="Löschen" (click)="delete(element.delivery);" class="m-xs">
              <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">delete</mat-icon>
            </a>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple></mat-row>
      </mat-table>
      @if (!displayData.length) {
        <div class="my-m">
          Keine Nachlieferungen
        </div>
      }
    </div>
  }
</section>




